import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/loginview',
      name: 'loginview',
      component: () => import('@/views/Login.vue')
    },
    {
      path: '/mysearch',
      name: 'mysearch',
      component: () => import('@/views/MySearch.vue')
    },
    {
      path: '/edit',
      name: 'edit',
      component: () => import('@/views/Edit.vue')
    },
    {
      path: '/export',
      name: 'export',
      component: () => import('@/views/Export.vue')
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/views/Calendar.vue')
    },
    {
      path: '/information',
      name: 'informationboard',
      component: () => import('@/views/InformationBoard.vue')
    },
    {
      path: '/membertags',
      name: 'membertags',
      component: () => import('@/views/MemberTags.vue')
    },
    {
      path: '/privacyword',
      name: 'privacyword',
      component: () => import('@/views/PrivacyWord.vue')
    },
    {
      path: '/mytags',
      name: 'mytags',
      component: () => import('@/views/MyTags.vue')
    },
    {
      path: '/mypage',
      name: 'mypage',
      component: () => import('@/views/MyPage.vue')
    },
    {
      path: '/membersactivity',
      name: 'membersactivity',
      component: () => import('@/views/MembersActivity.vue')
    },
    {
      path: '/approvevacation',
      name: 'approvevacation',
      component: () => import('@/views/ApproveVacation.vue')
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/Users.vue')
    },
    {
      path: '/clients',
      name: 'clients',
      component: () => import('@/views/Clients.vue')
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('@/views/Projects.vue')
    },
    {
      path: '/assign',
      name: 'assign',
      component: () => import('@/views/ProjectAssigns.vue')
    },
    {
      path: '/teams',
      name: 'teams',
      component: () => import('@/views/TeamsIntegration.vue')
    },
    {
      path: '/projecttime',
      name: 'projecttime',
      component: () => import('@/views/ProjectTime.vue')
    }
  ]
})
